import { apiFetch } from "../useApi";

export default async function getAddressesStatistic() {
  const response = await apiFetch(`/addresses/statistic`);
  return response.json();
}
